import React from "react";
import { IContent, IPMBlock } from "../../../models/IPages";
import Input from "../../../components/UI/input/GgInput";


function InfoBlock({ data, setData, articles, actionData }: IPMBlock) {
  const handleInfoBlock = (index: number, val: string, type: keyof IContent) =>
    setData((prev: any) => {
      const newContent = [...prev.content];
      newContent[index][type] = val;
      return { ...prev, content: newContent };
    });

  return (
    <>
      <div className="title">Info Block</div>
      <div className="step-list col">
        <div className="step-item">
          <div className="step-title">Title</div>
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              value={data?.title}
              onChange={(val) => setData({ ...data, title: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="card-container">
          {[1, 2, 3].map((item: any, index: any) => {
            return (
              <div key={index} className="card">
                <Input
                  type="text"
                  value={data?.content[index].heading}
                  placeholder="Enter title"
                  onChange={(val) => handleInfoBlock(index, val, "heading")}
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  value={data?.content[index].description}
                  placeholder="Enter description"
                  onChange={(val) => handleInfoBlock(index, val, "description")}
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  label="Button name"
                  placeholder="Enter Button name"
                  value={data?.content[index]?.btnName}
                  onChange={(val) => handleInfoBlock(index, val, "btnName")}
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  label="Button link"
                  placeholder="Enter link"
                  value={data?.content[index].link}
                  onChange={(val) => handleInfoBlock(index, val, "link")}
                  disabled={!actionData?.edit}
                />
                {/* <FormSelect
                  list={articles}
                  defaultValue={data?.content[index].link}
                  label="Page link"
                  onChange={(val) => handleInfoBlock(index, val.value, "link")}
                /> */}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default InfoBlock;
